// Constants for Employee Management

export const ADVANCE_REASONS = [
  { value: 'ration', label: 'Ration' },
  { value: 'recharge', label: 'Recharge' },
  { value: 'salary_advance', label: 'Salary Advance' },
  { value: 'other', label: 'Other' }
];

export const PAYMENT_METHODS = ['Cash', 'Credit Card', 'Debit Card', 'Bank Transfer', 'UPI', 'Check'];

// Prevent scroll wheel from changing number input values
export const preventWheelChange = (e) => {
  e.target.blur();
};
